
import ScoreCalculator from './ScoreCalculator.js';
import Deck from './Deck.js';
import Random from './Random.js';
export default class Analyzer {
    constructor() {
        this.debug = false;
    }
    analyzeHandByIds(dealtHandIds, isDealer, handCardsIds) {
        let dealtHand = Deck.createCardsFromArrayString(dealtHandIds);
        let handCards = Deck.createCardsFromArrayString(handCardsIds);
        return this.analyzeHand(dealtHand, isDealer, handCards);
    }
    analyzeHand(dealtHand, isDealer, handCards, enhanced) {
        if (!dealtHand) dealtHand = [];
        if (!handCards) handCards = [];
        dealtHand.sort((a, b) => a.number - b.number);
        handCards.sort((a, b) => a.number - b.number);
        if (!dealtHand) return [];
        let options = this.findAllPossbileHandsWithScores_FactorInCrib(dealtHand, isDealer, enhanced);

        //add ranking and clean up data
        let ranks = this.rank(options, (a, b) => { return b.avgScore - a.avgScore; });
        let handRanks = this.rank(options, (a, b) => { return b.avgHandScore - a.avgHandScore; });
        for (let i = 0; i < options.length; i++) {
            let option = options[i];
            let rank = ranks[i];
            let handRank = handRanks[i];
            let percentile = Math.round((1 - ((rank - 1) / options.length)) * 100);
            let handPercentile = Math.round((1 - ((handRank - 1) / options.length)) * 100);
            let avgScore = Math.round((option.avgScore) * 10) / 10;
            let avgHandScore = Math.round((option.avgHandScore) * 10) / 10;

            option.rank = rank;
            option.avgScorePercentile = percentile;
            option.avgHandScorePercentile = handPercentile;
            option.cards = option.cards.sort((a, b) => a.number - b.number);
            option.cribCards = option.cribCards.sort((a, b) => a.number - b.number);
            option.avgHandScore = avgHandScore;
            option.avgScore = avgScore;
        }
        options.sort((a, b) => { return b.avgScore - a.avgScore; });

        //mark selected hand
        if (handCards && handCards.length !== 0) {
            let selectedOption = this.findHand(options, handCards);
            if (selectedOption) selectedOption.selected = true;
        }

        let data = {
            preHand: dealtHand,
            isDealer: isDealer,
            hand: handCards,
            options: options
        }
        return data;
    }
    round(number) {
        return Math.round((number + Number.EPSILON) * 100) / 100;
    }
    rank(arr, f) {
        return arr
            .map((x, i) => [x, i])
            .sort((a, b) => f(a[0], b[0]))
            .reduce((a, x, i, s) => (a[x[1]] =
                i > 0 && f(s[i - 1][0], x[0]) === 0 ? a[s[i - 1][1]] : i + 1, a), []);
    }
    findHand(options, handCards) {

        let selectedOption = options.find(function (option) {
            if (!option) return false;
            if (!option.cards) return false;
            if (!handCards) return false;
            return this.compareArray(option.cards.slice().map(c => c.id).sort(), handCards.slice().map(c => c.id).sort());
        }.bind(this));
        return selectedOption
    }
    compareArray(array1, array2) {
        // if the other array is a falsy value, return
        if (!array2)
            return false;

        // compare leng ths - can save a lot of time
        if (array1.length != array2.length)
            return false;

        for (var i = 0; i < array1.length; i++) {

            if (array1[i] != array2[i]) {
                // Warning - two different object instances will never be equal: {x:20} != {x:20}
                return false;
            }
        }
        return true;
    }
    findAllPossbileHandsWithScores(handCards) {

        //input: 6 cards
        //proc: add one unknown
        //output: All options and scores possiblities with 5 cards, 4 from the 6 plus one unknown
        let calc = new ScoreCalculator();
        let allcombos = calc.findAllCombinations(handCards, 4, 4);
        let deck = new Deck().createDeck();
        let unknownCards = this.subractCardArrayFromCardArray(deck, handCards);
        let options = [];
        //each combo
        for (let i = 0; i < allcombos.length; i++) {
            let cardCombo = allcombos[i];
            let possibleScores = [];
            //each unknown card
            for (let j = 0; j < unknownCards.length; j++) {
                let unknownCard = unknownCards[j];
                //create possible hand
                let possibleHand = cardCombo.concat([unknownCard]);
                let possibleHandPointLogs = calc.scoreHand(unknownCard, cardCombo);
                let possibleHandScore = possibleHandPointLogs.reduce((total, pointLog) => total + pointLog.points, 0);
                possibleScores.push(possibleHandScore);
            }
            possibleScores.sort(function (a, b) { return a - b });
            let totalScore = possibleScores.reduce((total, amount) => total + amount, 0);
            let avgScore = totalScore / possibleScores.length;
            let maxScore = possibleScores[possibleScores.length - 1];
            let minScore = possibleScores[0];
            let medScore = possibleScores[Math.round((possibleScores.length - 1) / 2)];
            let option = {
                cards: cardCombo,
                maxScore: maxScore,
                avgScore: avgScore,
                medScore: medScore,
                minScore: minScore
            };
            options.push(option);
        }

        //todo: get crib options

        return options;
    }
    findAllPossbileHandsWithScores_FactorInCrib(handCards, isDealer, enhanced) {
        if (!enhanced) enhanced = true;
        let debug = this.debug;
        //input: 6 cards
        //proc: add one unknown
        //output: All options and scores possiblities with 5 cards, 4 from the 6 plus one unknown
        let calc = new ScoreCalculator();
        let allcombos = calc.findAllCombinations(handCards, 4, 4);
        let deck = new Deck().createDeck();
        let unknownCards = this.subractCardArrayFromCardArray(deck, handCards);
        let options = [];
        //each combo
        for (let i = 0; i < allcombos.length; i++) {
            let cardCombo = allcombos[i];
            let cribCards = this.subractCardArrayFromCardArray(handCards, cardCombo);
            let possibleScores = [];
            let possibleHandAndScore = [];
            //each unknown card
            for (let j = 0; j < unknownCards.length; j++) {
                let unknownCard = unknownCards[j];
                //create possible hand
                let possibleHandPointLogs = calc.scoreHand(unknownCard, cardCombo);
                let possibleHandScore = possibleHandPointLogs.reduce((total, pointLog) => total + pointLog.points, 0);
                possibleScores.push(possibleHandScore);
                if (debug) {
                    let cardsText = cardCombo.map(c => c.face + c.symbol);
                    let summary = possibleHandScore + " : [" + unknownCard.face + unknownCard.symbol + "]," + cardsText.join(",") + " = " + possibleHandScore + " points";
                    possibleHandAndScore.push(summary);
                }
            }
            if (debug) {
                possibleHandAndScore.sort();
                console.log(possibleHandAndScore);
            }

            possibleScores.sort(function (a, b) { return a - b });
            let totalScore = possibleScores.reduce((total, amount) => total + amount, 0);
            let avgHandScore = totalScore / possibleScores.length;
            let maxHandScore = possibleScores[possibleScores.length - 1];
            let minHandScore = possibleScores[0];
            let medHandScore = possibleScores[Math.round((possibleScores.length - 1) / 2)];

            //console.log("maxHandScore = " + maxHandScore);  

            //get crib estimate points
            let cribPoints = 0;

            if (enhanced) cribPoints = cribPoints = this.cribEstimateLookUp(cribCards);
            if (!enhanced) cribPoints = this.cribEstimate(cribCards, cardCombo);

            if (isDealer == false) cribPoints = cribPoints * -1;
            //round to 1 decimal place
            cribPoints = Math.round(cribPoints * 10) / 10;

            let avgScore = avgHandScore + cribPoints;
            let option = {
                cards: cardCombo,
                maxHandScore: maxHandScore,
                avgHandScore: avgHandScore,
                medHandScore: medHandScore,
                minHandScore: minHandScore,
                cribCards: cribCards,
                cribPoints: cribPoints,
                avgScore: avgScore,
            };
            options.push(option);
        }

        //todo: get crib options

        return options;
    }
    cribEstimate(cribCards) {
        let deck = new Deck().createDeck("", true);
        let calc = new ScoreCalculator();
        let possibleScores = [];
        let possibleCribPointLogs = [];
        let unknownCards = this.subractCardArrayFromCardArray(deck, cribCards);
        for (let j = 0; j < unknownCards.length; j++) {
            let unknownCard = unknownCards[j];
            //create possible hand of 3
            let possibleCribPointLog = calc.scoreCrib(unknownCard, cribCards);
            possibleCribPointLogs.push(possibleCribPointLog);
            let possibleCribScore = possibleCribPointLog.reduce((total, pointLog) => total + pointLog.points, 0);
            possibleScores.push(possibleCribScore);
        }
        //todo: calc the chances of getting at least one of the 3 remaing and order by points
        //this is just an average and only good in the case there are 3 crib cards but there are 5
        //idea: instead of finding all values and avg, find all combos that have a value of higher than n points and work backwards.

        let totalScore = possibleScores.reduce((total, amount) => total + amount, 0);
        let avgScore = totalScore / possibleScores.length;

        // console.log(avgScore);
        // console.log(cribCards); 
        // console.log(possibleScores);
        // console.log(possibleCribPointLogs);

        return avgScore;
    }
    cribEstimateLookUp(cribCards) {
        let cribTable = {
            '1,1': 4.57,
            '1,2': 3.46,
            '1,3': 3.55,
            '1,4': 4.44,
            '1,5': 4.73,
            '1,6': 3.26,
            '1,7': 3.09,
            '1,8': 3.14,
            '1,9': 3.09,
            '1,10': 2.98,
            '1,11': 3.18,
            '1,12': 2.81,
            '1,13': 2.73,
            '2,1': 3.42,
            '2,2': 4.82,
            '2,3': 5.84,
            '2,4': 3.82,
            '2,5': 4.75,
            '2,6': 3.37,
            '2,7': 3.23,
            '2,8': 3.23,
            '2,9': 3.16,
            '2,10': 3.03,
            '2,11': 3.3,
            '2,12': 3,
            '2,13': 2.89,
            '3,1': 3.59,
            '3,2': 5.84,
            '3,3': 5.16,
            '3,4': 4.54,
            '3,5': 5.43,
            '3,6': 3.21,
            '3,7': 3.33,
            '3,8': 3.3,
            '3,9': 3.13,
            '3,10': 3.2,
            '3,11': 3.35,
            '3,12': 3.02,
            '3,13': 2.91,
            '4,1': 4.45,
            '4,2': 3.87,
            '4,3': 4.5,
            '4,4': 5.12,
            '4,5': 6.04,
            '4,6': 3.92,
            '4,7': 3.17,
            '4,8': 3.28,
            '4,9': 3.19,
            '4,10': 3.14,
            '4,11': 3.38,
            '4,12': 3.06,
            '4,13': 2.97,
            '5,1': 4.73,
            '5,2': 4.72,
            '5,3': 5.4,
            '5,4': 5.97,
            '5,5': 7.93,
            '5,6': 6.04,
            '5,7': 5.43,
            '5,8': 4.74,
            '5,9': 4.72,
            '5,10': 6.02,
            '5,11': 6.24,
            '5,12': 5.9,
            '5,13': 5.79,
            '6,1': 3.28,
            '6,2': 3.38,
            '6,3': 3.3,
            '6,4': 3.96,
            '6,5': 6.1,
            '6,6': 5.25,
            '6,7': 4.51,
            '6,8': 3.88,
            '6,9': 4.6,
            '6,10': 2.82,
            '6,11': 3.01,
            '6,12': 2.74,
            '6,13': 2.62,
            '7,1': 3.09,
            '7,2': 3.26,
            '7,3': 3.34,
            '7,4': 3.17,
            '7,5': 5.4,
            '7,6': 4.51,
            '7,7': 5.1,
            '7,8': 5.74,
            '7,9': 3.35,
            '7,10': 2.73,
            '7,11': 3.01,
            '7,12': 2.69,
            '7,13': 2.53,
            '8,1': 3.09,
            '8,2': 3.22,
            '8,3': 3.31,
            '8,4': 3.31,
            '8,5': 4.78,
            '8,6': 3.87,
            '8,7': 5.75,
            '8,8': 4.63,
            '8,9': 3.96,
            '8,10': 3.25,
            '8,11': 2.95,
            '8,12': 2.66,
            '8,13': 2.53,
            '9,1': 3,
            '9,2': 3.12,
            '9,3': 3.14,
            '9,4': 3.2,
            '9,5': 4.7,
            '9,6': 4.49,
            '9,7': 3.36,
            '9,8': 3.96,
            '9,9': 4.52,
            '9,10': 3.85,
            '9,11': 3.51,
            '9,12': 2.55,
            '9,13': 2.48,
            '10,1': 2.95,
            '10,2': 3.07,
            '10,3': 3.14,
            '10,4': 3.14,
            '10,5': 6.03,
            '10,6': 2.87,
            '10,7': 2.67,
            '10,8': 3.25,
            '10,9': 3.85,
            '10,10': 4.49,
            '10,11': 4.04,
            '10,12': 3.13,
            '10,13': 2.42,
            '11,1': 3.19,
            '11,2': 3.27,
            '11,3': 3.41,
            '11,4': 3.36,
            '11,5': 6.23,
            '11,6': 3.04,
            '11,7': 2.99,
            '11,8': 2.89,
            '11,9': 3.5,
            '11,10': 4.04,
            '11,11': 4.95,
            '11,12': 3.99,
            '11,13': 3.32,
            '12,1': 2.84,
            '12,2': 2.95,
            '12,3': 3.05,
            '12,4': 3.01,
            '12,5': 5.9,
            '12,6': 2.76,
            '12,7': 2.68,
            '12,8': 2.66,
            '12,9': 2.55,
            '12,10': 3.08,
            '12,11': 3.97,
            '12,12': 4.23,
            '12,13': 2.98,
            '13,1': 2.77,
            '13,2': 2.86,
            '13,3': 2.88,
            '13,4': 2.84,
            '13,5': 5.81,
            '13,6': 2.61,
            '13,7': 2.57,
            '13,8': 2.57,
            '13,9': 2.44,
            '13,10': 2.37,
            '13,11': 3.35,
            '13,12': 3.01,
            '13,13': 4.01
        };
        if (!cribCards) return 0;
        if (cribCards.length != 2) return 0;
        let card1 = cribCards[0];
        let card2 = cribCards[1];
        let lookupKey = card1.number + ',' + card2.number;
        let score = cribTable[lookupKey];
        return score;
    }
    cribEstimateRandom(cribCards, handCards, sampleSize) {
        if (!sampleSize) sampleSize = 100;
        let deck = new Deck().createDeck("", true);
        let calc = new ScoreCalculator();
        let possibleScores = [];
        let possibleCribPointLogs = [];
        deck = this.subractCardArrayFromCardArray(deck, cribCards);
        deck = this.subractCardArrayFromCardArray(deck, handCards);

        //note: to calculate all combos for the last 3 card, there is 103,776 posiblities
        //take a random sample from 100
        for (let i = 0; i < sampleSize; i++) {
            //get 3 random cards from the deck
            let unknownCards = this.get3RandomCards(deck);
            let starterCard = unknownCards.pop();
            let allCribCards = cribCards.concat(unknownCards);
            //create possible hand of 3
            let possibleCribPointLog = calc.scoreCrib(starterCard, allCribCards);
            possibleCribPointLogs.push(possibleCribPointLog);
            let possibleCribScore = possibleCribPointLog.reduce((total, pointLog) => total + pointLog.points, 0);
            possibleScores.push(possibleCribScore);
        }
        //todo: calc the chances of getting at least one of the 3 remaing and order by points
        //this is just an average and only good in the case there are 3 crib cards but there are 5
        //idea: instead of finding all values and avg, find all combos that have a value of higher than n points and work backwards.

        let totalScore = possibleScores.reduce((total, amount) => total + amount, 0);
        let avgScore = totalScore / possibleScores.length;

        // console.log(avgScore);
        // console.log(cribCards); 
        // console.log(possibleScores);
        // console.log(possibleCribPointLogs);

        return avgScore;
    }
    get3RandomCards(deck) {
        let random = new Random(); //no seed, it will seed itself
        let cards = [];
        while (cards.length < 3) {
            let randomIndex = random.randomInt(0, deck.length);
            let card = deck[randomIndex];
            //check if card is already in the array
            if (!cards.includes(card)) {
                cards.push(card);
            }
        }
        return cards;
    }
    subractCardArrayFromCardArray(cardArray1, cardArray2) {
        let outputCards = [];
        //get all unknown cards (not in hand)
        for (let i = 0; i < cardArray1.length; i++) {
            let card = cardArray1[i];
            //if not in hand then add to output array
            var cards = cardArray2.filter(function (c) {
                let id1 = c.id || c;
                let id2 = card.id || card;
                return id1 === id2;
            });
            if (cards.length === 0) {
                outputCards.push(card);
            }
        }
        return outputCards;
    }
    //genereate list of all crib scores
    getCribScores(sampleSize) {
        if (!sampleSize) sampleSize = 100;
        let cardCardPosibilities1 = Deck.createCardsFromArrayString('ad,2d,3d,4d,5d,6d,7d,8d,9d,10d,jd,qd,kd');
        let cardCardPosibilities2 = Deck.createCardsFromArrayString('ac,2c,3c,4c,5c,6c,7c,8c,9c,10c,jc,qc,kc');

        let cribScores = {};
        for (let i = 0; i < cardCardPosibilities1.length; i++) {
            let card1 = cardCardPosibilities1[i];
            for (let j = 0; j < cardCardPosibilities2.length; j++) {
                let card2 = cardCardPosibilities2[j];
                let score = this.cribEstimateRandom([card1, card2], [], sampleSize);
                score = Math.round(score * 100) / 100; //round to 2 decimal places
                //subtract 1 but not less than zero
                score = Math.max(score - 1, 0);
                cribScores[card1.number + ',' + card2.number] = score;
            }
        }
        return cribScores;
    }
}